//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
    data(){
        return{
            loading: this.$store.state.mutations.loading
        }
    },
    watch:{
        "$store.state.mutations.loading": function(newValue,oldValue){
            this.loading = newValue;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/common/loading/Loading.vue